import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';

export const openDescriptionModal: ApiTableCommandFactory =
  (cmdContext) => async () => {
    cmdContext.updateState((draft) => {
      draft.description.open = true;
    });
  };
